import { useEffect, useState } from "react";
import "./Categories.css";

//FontAwesome Imports
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingOutlined } from "@ant-design/icons";


import {Spin} from 'antd';
import { getCategoriesLookup, getProductsByCategory } from "../../../services/inventoryService";
import generateRandomColors from "../../../hooks/useRandomColor";
import { highlightLocations } from "../../../utils/helpers";
import { eventEmiterInstance } from "../../../utils/EventEmitter";


const Categories = ({ vref, isActive }) => {
  
  // --- States ---
  const [Categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loader,setLoader] = useState({categorysLoader:false,productsByCategoryLoader:false});
  const [message, setMessage] = useState(null);


  const onSelectCategoryHandler = async(category) =>{

    if(!category || !category.categoryId) return;
    if(selectedCategory?.categoryId === category.categoryId){
      setSelectedCategory(null);
      eventEmiterInstance.emit('resetAllRacks',{});
      return;
    }

    setSelectedCategory(category);
    const productsByCategory = await fetchProductsByCategory(category.categoryId) || [];
    if(productsByCategory.length === 0) setMessage("No records found");
    const storageLocationCodes = productsByCategory?.map(({storage_location}) => storage_location);
    highlightLocations(storageLocationCodes);
  }


  //Fetch Categories
  const fetchCategoriesLookup = async () =>{
    setLoader({categorysLoader:true,productsByCategoryLoader:false});
    try{
      let categoriesLookup = await getCategoriesLookup();
      if(categoriesLookup.length === 0) setMessage("No records found");

      const categoryColors = generateRandomColors(categoriesLookup?.length);
      let modifiedCategoriesLookup = categoriesLookup.map((category,index) => ({...category,categoryColor:categoryColors[index]}));
      setCategories(modifiedCategoriesLookup);
    }catch (error) {
      console.log("error", error);
    }finally{
       setLoader({categorysLoader:false,productsByCategoryLoader:false});
    }
  }


  const fetchProductsByCategory = async (categoryId) => {
     setLoader({categorysLoader:false,productsByCategoryLoader:true});
    try{
      const categoryProducts = await getProductsByCategory(categoryId);
      return categoryProducts;
    } catch (error) {
      console.log("error", error);
    } finally {
       setLoader({categorysLoader:false,productsByCategoryLoader:false});
    }
  }


  useEffect(() => {
    if (isActive) {
      fetchCategoriesLookup();
    }
    return () => {
      setCategories([]);
      setSelectedCategory(null);
      setMessage(null);
      setLoader({categorysLoader:false,productsByCategoryLoader:false});
    };
  }, [isActive]);

  return (
    <div className="categories-container">
      {Categories?.length > 0 && (
        <div className="categories-list-wrapper">
          {Categories.map((item, index) => {
            return (
              <div className={`category-item ${selectedCategory?.categoryId === item.categoryId ? "active-category" : ""}`} key={item.categoryId} onClick={() => onSelectCategoryHandler(item)}>
                <div className="category-info">
                  <div className="category-color-indication" style={{ backgroundColor: item.categoryColor }}></div>
                  <div className="category-title">{item.categoryName}</div>
                </div>
                <div className="category-actions"> 
                  {
                    (loader?.productsByCategoryLoader && selectedCategory?.categoryId === item.categoryId) && <LoadingOutlined theme="outlined"  className="category-loader" style={{color:'#576ec1',fontSize:'18px',strokeWidth: "50"}} />
                  }
                </div>
              </div>
            );
          })}
        </div>
      )}

       {/* Loading Indicator */}
      {loader?.categorysLoader && (<div className="loading-overlay"><Spin size="medium"/> </div>)}
  
      {message?.length && (
        <div className="message-info">
          {message}
        </div>
      )}
      
    </div>
  );
};

export default Categories;
